import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  getListingManagedPhotoUrls,
  isFallbackImage,
} from 'common/listingHelpers';
import withInfiniteScroll from 'client/helpers/withInfiniteScroll';
import SrLink from 'client/components/SrLink/SrLink';
import SrGridRow from 'client/components/SrGridRow/SrGridRow';
import ListingCard from './ListingCard';

@withInfiniteScroll({
  offset: 32,
  savePositionWithId: (props) => {
    return props.savePositionWithId;
  },
})
class ListingsListViewV2 extends Component {
  static propTypes = {
    listings: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onLoadMore: PropTypes.func,
    listingsTotal: PropTypes.number,
    listingsViewMoreIndex: PropTypes.number,
    listingsViewMoreCount: PropTypes.number,
    enableAllListings: PropTypes.func,
    currentUser: PropTypes.object.isRequired,
    savePositionWithId: PropTypes.string, // eslint-disable-line
    showRequestShowingButton: PropTypes.bool,
    householdApplications: PropTypes.array,
    photoResolution: PropTypes.number.isRequired,
    requestedFrom: PropTypes.string,
    renterProfile: PropTypes.object,
  }

  constructor(props) {
    super(props);

    const {
      onInfiniteScrollCallbackReady,
      onLoadMore,
    } = props;

    if (onLoadMore && onInfiniteScrollCallbackReady) {
      onInfiniteScrollCallbackReady(onLoadMore);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { listingsIsFullyLoaded, enableAllListings } = this.props;
    const shouldEnableAllListings = (
      listingsIsFullyLoaded
      && nextProps.listingsViewMoreIndex === null
      && nextProps.listingsViewMoreCount !== 0
      && nextProps.listingsViewMoreCount - nextProps.listingsTotal > 0
    );
    if (shouldEnableAllListings) {
      enableAllListings();
    }
  }

  render() {
    // HACK(@d-oliveros): Not showing listings with fallback images.
    const listings = this.props.listings.filter((listing) => {
      const managedPhotoUrls = getListingManagedPhotoUrls({ listing });
      return managedPhotoUrls && managedPhotoUrls[0] && !isFallbackImage(managedPhotoUrls[0]);
    });
    const {
      isLoading,
      onInfiniteScrollWrapperRef,
      listingsTotal,
      listingsViewMoreIndex,
      currentUser,
      showRequestShowingButton,
      householdApplications,
      photoResolution,
      requestedFrom,
      renterProfile,
    } = this.props;

    const householdApplicationStatusesByListingId = !householdApplications ? {} : (
      householdApplications.reduce((memo, { id, status }) => ({
        ...memo,
        [id]: status,
      }), {})
    );

    return (
      <div
        ref={onInfiniteScrollWrapperRef}
        style={{
          margin: '0 auto',
          maxWidth: '1200px',
        }}
      >
        <SrGridRow
          autofit
          autofitMinColumnWidth='calc(33% - 10px)'
          columnGap='10px'
          rowGap='10px'
          maxWidth='100%'
          columnWrapMobile
          columnWrapTablet
        >
          {listings.reduce((acc, listing, index) => {
            if (index === listingsViewMoreIndex) {
              acc.push(
                <div className='results-filter-divider-container clearfix' key='listing-divider'>
                  <div className='results-filter-divider'>
                    <span>
                      {listingsTotal - listingsViewMoreIndex + ' rentals outside your '}
                      <SrLink to='/search' className='link-search'>search filters</SrLink>:
                    </span>
                  </div>
                </div>
              );
            }
            acc.push(
              <ListingCard
                requestedFrom={requestedFrom}
                enableBookmarkButton
                key={listing.id}
                listing={listing}
                currentUser={currentUser}
                showRequestShowingButton={showRequestShowingButton}
                applicationStatus={householdApplicationStatusesByListingId[listing.id]}
                photoResolution={photoResolution}
                renterProfile={renterProfile}
                noMaxWidth
              />
            );
            return acc;
          }, [])}

          {isLoading && (
            <div className='loading-gif clearfix' />
          )}
        </SrGridRow>
      </div>
    );
  }
}

ListingsListViewV2.displayName = 'ListingsListViewV2';

export default ListingsListViewV2;
